import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import parseGoogleLatLng from '../helper/parse_google_lat_lng';
import {noop, isEqual} from '../../../lib/utilities';

class MapStoreClass extends ReduceStore {
    constructor(dispatcher) {
        super(dispatcher);
    }

    getInitialState() {
        return {
            fetching: false,
            latLng: {
                lat: noop,
                lng: noop,
            },
            zoomLvl: 0,
        };
    }

    reduce(state, { source, action }) {
        if (source === 'MAP_ACTION') {
            switch (action.type) {
            case 'FETCH_LATLNG':
                if (!state.fetching) {
                    state.fetching = true;
                    this.__emitChange();
                }
                break;

            case 'LATLNG_FETCHED':
                state.fetching = false;
                state = this._updateLatLng(state, action.payload);
                break;
            case 'SET_LATLNG':
                state = this._updateLatLng(state, action.payload);
                break;
            case 'UPDATE_ZOOM_LVL':
                state = this._updateZoomLvl(state, action.payload);
                break;
            }
        }

        return state;
    }

    _updateLatLng(state, latLng) {
        const stateLatLng = parseGoogleLatLng(state.latLng);
        const newLatLng = parseGoogleLatLng(latLng);

        if (!isEqual(stateLatLng, newLatLng)) {
            state.latLng = latLng;
        }
        this.__emitChange();

        return state;
    }

    _updateZoomLvl(state, zoomLvl) {
        if (state.zoomLvl !== zoomLvl) {
            state.zoomLvl = zoomLvl;
            this.__emitChange();
        }

        return state;
    }
}

const MapStore = new MapStoreClass(Dispatcher);
export default MapStore;
